export default __webpack_public_path__ + "static/media/dropdown-arrow.7b4a6bcf.svg";